package com.vizio.redwolf.pay.model

data class OfferIdByLinkingPinRequestInfo(
    val linkingPin: String? = null,
    val deviceInstanceId: String? = null,
    val m2mToken: String
)